import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';

import { Grid, Fab, Stack } from '@mui/material';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

import { isEmpty, map, cloneDeep } from 'lodash';

import MapsAdvancedAnnotationDirectButtons from '../MapsAdvancedAnnotationDirectButtons';
import MapsAdvancedCatastroField from '../MapsAdvancedCatastroField';
import MapsAdvancedDownloadLinksField from '../MapsAdvancedDownloadLinksField';
import MapsAdvancedFileToolsField from '../MapsAdvancedFileToolsField';
import MapsAdvancedGeneralSettingsField from '../MapsAdvancedGeneralSettingsField';
import MapsAdvancedInfoLayerField from '../MapsAdvancedInfoLayerField';
import MapsAdvancedIntroductionField from '../MapsAdvancedIntroductionField';
import MapsAdvancedISLField from '../MapsAdvancedISLField';
import MapsAdvancedLayersControlField from '../MapsAdvancedLayersControlField';
import MapsAdvancedLocationField from '../MapsAdvancedLocationField';
import MapsAdvancedMapDeckField from '../MapsAdvancedMapDeckField';
import MapsAdvancedNotesField from '../MapsAdvancedNotesField';
import MapsAdvancedPointMapField from '../MapsAdvancedPointMapField';
import MapsAdvancedSentinelField from '../MapsAdvancedSentinelField';
import MapsAdvancedSharedField from '../MapsAdvancedSharedField';
import MapsAdvancedTableSourceField from '../MapsAdvancedTableSourceField';
import MapsAdvancedViewLinksField from '../MapsAdvancedViewLinksField';
import MapsAdvancedTableAnnotationsField from '../MapsAdvancedTableAnnotationsField';
import MapsAdvancedPythonField from '../MapsAdvancedPythonField';

const MapsAdvancedModalStepTwo = props => {
  const {
    defaultComponent,
    handleDisabledFinish,
    ipsOfIsl,
    listComponentsAdvanced,
    mapTypes,
    notes,
    textSettings,
    settingsAdvanced,
    userControlSetting
  } = props;
  const [componentToRender, setComponentToRender] = React.useState('');
  const [listAdvancedCheck, setListAdvancedCheck] = React.useState(listComponentsAdvanced);

  const renderComponent = async component => {
    switch (component) {
      case 'AnnotationDirectButtons':
        setComponentToRender(<MapsAdvancedAnnotationDirectButtons {...props} />);
        break;
      case 'CatastroComponent':
        setComponentToRender(<MapsAdvancedCatastroField {...props} />);
        break;
      case 'DownloadLinksComponent':
        setComponentToRender(<MapsAdvancedDownloadLinksField {...props} />);
        break;
      case 'FileToolsComponent':
        setComponentToRender(<MapsAdvancedFileToolsField {...props} />);
        break;
      case 'InfoLayerSelection':
        setComponentToRender(<MapsAdvancedInfoLayerField {...props} />);
        break;
      case 'IntroductionMapComponent':
        setComponentToRender(<MapsAdvancedIntroductionField {...props} />);
        break;
      case 'ISLComponent':
        setComponentToRender(<MapsAdvancedISLField {...props} />);
        break;
      case 'LayersControl':
        setComponentToRender(<MapsAdvancedLayersControlField {...props} />);
        break;
      case 'LocationComponent':
        setComponentToRender(<MapsAdvancedLocationField {...props} />);
        break;
      case 'NotesComponent':
        setComponentToRender(<MapsAdvancedNotesField {...props} />);
        break;
      case 'PointMapComponent':
        setComponentToRender(<MapsAdvancedPointMapField {...props} />);
        break;
      case 'PythonComponent':
        setComponentToRender(<MapsAdvancedPythonField {...props} />);
        break;
      case 'SentinelComponent':
        setComponentToRender(<MapsAdvancedSentinelField {...props} />);
        break;
      case 'SharedComponent':
        setComponentToRender(<MapsAdvancedSharedField {...props} />);
        break;
      case 'ShowMapDeckLidarComponent':
        setComponentToRender(<MapsAdvancedMapDeckField {...props} />);
        break;
      case 'TableAnnotationsComponent':
        setComponentToRender(<MapsAdvancedTableAnnotationsField {...props} />);
        break;
      case 'TableSourceComponent':
        setComponentToRender(<MapsAdvancedTableSourceField {...props} />);
        break;
      case 'ViewLinksComponent':
        setComponentToRender(<MapsAdvancedViewLinksField {...props} />);
        break;
      case 'generalSettings':
        setComponentToRender(<MapsAdvancedGeneralSettingsField {...props} />);
        break;
      default:
        setComponentToRender(<MapsAdvancedGeneralSettingsField {...props} />);
        break;
    }
  };

  const checkedSettings = () => {
    const listCheckedAdvanced = cloneDeep(listComponentsAdvanced);
    map(Object.keys(listCheckedAdvanced), key => {
      switch (key) {
        case 'AnnotationDirectButtons':
          if (listCheckedAdvanced[key].show) {
            if (
              isEmpty(settingsAdvanced.directButtons.videoId) ||
              isEmpty(settingsAdvanced.directButtons.projectId)
            )
              listCheckedAdvanced[key].isCheck = false;
            else listCheckedAdvanced[key].isCheck = true;
          }
          break;

        case 'LocationComponent':
          if (listCheckedAdvanced[key].show) {
            if (
              isEmpty(settingsAdvanced.locationSettings.videoId) ||
              isEmpty(settingsAdvanced.locationSettings.projectId)
            )
              listCheckedAdvanced[key].isCheck = false;
            else listCheckedAdvanced[key].isCheck = true;
          }
          break;
        // case 'DownloadLinksComponent':
        //   if (listCheckedAdvanced[key].show) {
        //     if (
        //       !isEmpty(connections.connector.name) &&
        //       !isEmpty(connections.server.name) &&
        //       !isEmpty(connections.source.name)
        //     ) {
        //       listCheckedAdvanced[key].isCheck = true;
        //     } else listCheckedAdvanced[key].isCheck = false;
        //   }
        //   break;
        case 'CatastroComponent':
          if (listCheckedAdvanced[key].show) {
            if (
              !isEmpty(settingsAdvanced.downloadLinks.connector) &&
              !isEmpty(settingsAdvanced.downloadLinks.server)
            ) {
              listCheckedAdvanced[key].isCheck = true;
            } else listCheckedAdvanced[key].isCheck = false;
          }
          break;
        case 'TableAnnotationsComponent':
          if (listCheckedAdvanced[key].show) {
            const videoIdCheck = !isEmpty(settingsAdvanced.tableAnnotations.videoId);
            const templateIdCheck = !isEmpty(settingsAdvanced.tableAnnotations.templateId);
            const isValidNumberOrString = value =>
              (typeof value === 'number' || typeof value === 'string') && value !== '';
            const orderElementCheck = isValidNumberOrString(
              settingsAdvanced.tableAnnotations.orderElement
            );
            listCheckedAdvanced[key].isCheck = videoIdCheck && templateIdCheck && orderElementCheck;
          }
          break;
        case 'FileToolsComponent':
          if (listCheckedAdvanced[key].show) {
            if (
              settingsAdvanced.fileTools.urlToUpload &&
              !isEmpty(settingsAdvanced.fileTools.urlToUpload)
            ) {
              if (
                settingsAdvanced.fileTools.geojsonFunction &&
                settingsAdvanced.fileTools.geojsonFunction === true
              ) {
                if (
                  settingsAdvanced.fileTools.serverConnection &&
                  !isEmpty(settingsAdvanced.fileTools.serverConnection)
                ) {
                  listCheckedAdvanced[key].isCheck = true;
                }
              } else {
                listCheckedAdvanced[key].isCheck = true;
              }
            } else listCheckedAdvanced[key].isCheck = false;
          }
          break;
        case 'PythonComponent':
          if (listCheckedAdvanced[key].show) {
            if (
              !isEmpty(settingsAdvanced.pythonSettings.layerIDs) &&
              settingsAdvanced.pythonSettings.layerIDs.length === 2
            ) {
              listCheckedAdvanced[key].isCheck = true;
            } else listCheckedAdvanced[key].isCheck = false;
          }
          break;
        case 'PointMapComponent':
        case 'InfoLayerSelection':
        case 'LayersControl':
        case 'TableSourceComponent':
        case 'SentinelComponent':
        case 'SharedComponent':
        case 'ShowMapDeckLidarComponent':
          if (listCheckedAdvanced[key].show) {
            listCheckedAdvanced[key].isCheck = true;
          }
          break;
        case 'IntroductionMapComponent':
          if (listCheckedAdvanced[key].show) {
            if (isEmpty(mapTypes) && isEmpty(textSettings))
              listCheckedAdvanced[key].isCheck = false;
            else listCheckedAdvanced[key].isCheck = true;
          }
          break;
        case 'ISLComponent':
          if (listCheckedAdvanced[key].show) {
            if (isEmpty(ipsOfIsl.links)) listCheckedAdvanced[key].isCheck = false;
            else listCheckedAdvanced[key].isCheck = true;
          }
          break;
        case 'NotesComponent':
          if (listCheckedAdvanced[key].show) {
            if (isEmpty(notes.videos)) listCheckedAdvanced[key].isCheck = false;
            else listCheckedAdvanced[key].isCheck = true;
          }
          break;
        case 'ViewLinksComponent':
          if (listCheckedAdvanced[key].show) {
            if (isEmpty(settingsAdvanced.viewLinks)) listCheckedAdvanced[key].isCheck = false;
            else listCheckedAdvanced[key].isCheck = true;
          }
          break;
        default:
          break;
      }
    });

    const isExistNotCheck = Object.values(listCheckedAdvanced).some(value => {
      const valueToReturn = value.isCheck === false;
      return valueToReturn;
    });

    let isDisabledFinish = true;
    if (!isEmpty(defaultComponent) && !isExistNotCheck) isDisabledFinish = false;
    handleDisabledFinish(isDisabledFinish);
    setListAdvancedCheck(listCheckedAdvanced);
  };

  React.useEffect(() => {
    if (!isEmpty(listComponentsAdvanced)) checkedSettings();
  }, [listComponentsAdvanced, notes, settingsAdvanced, defaultComponent, ipsOfIsl]);

  return (
    <Grid container>
      <Grid item xs={2} md={2}>
        <Stack direction="column" justifyContent="space-around" spacing={1}>
          {userControlSetting.advancedComponents.map(key => {
            if (!listComponentsAdvanced[key]) {
              return null;
            }
            if (listComponentsAdvanced[key].show === true) {
              return (
                <Fab
                  key={key}
                  onClick={() => renderComponent(key)}
                  size="small"
                  style={{
                    color: 'white',
                    backgroundColor: '#2A3F90',
                    boxShadow: 'none',
                    direction: 'row',
                    justifyContent: 'space-between'
                  }}
                  variant="extended"
                >
                  {listComponentsAdvanced[key].name}
                  {!listAdvancedCheck[key].isCheck && (
                    <CheckCircleOutlineRoundedIcon key={uuid()} color="error" />
                  )}
                  {listAdvancedCheck[key].isCheck && (
                    <CheckCircleOutlineRoundedIcon key={uuid()} color="success" />
                  )}
                </Fab>
              );
            }
            return '';
          })}
          <Fab
            onClick={() => renderComponent('generalSettings')}
            size="small"
            style={{
              color: 'white',
              backgroundColor: '#2A3F90',
              boxShadow: 'none',
              direction: 'row',
              justifyContent: 'space-between'
            }}
            variant="extended"
          >
            Opciones generales
            {isEmpty(defaultComponent) && (
              <CheckCircleOutlineRoundedIcon key={uuid()} color="error" />
            )}
            {!isEmpty(defaultComponent) && (
              <CheckCircleOutlineRoundedIcon key={uuid()} color="success" />
            )}
          </Fab>
        </Stack>
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={9} md={9}>
        {componentToRender}
      </Grid>
    </Grid>
  );
};

export default MapsAdvancedModalStepTwo;

MapsAdvancedModalStepTwo.defaultProps = {
  connections: {},
  defaultComponent: '',
  handleDisabledFinish: () => {},
  ipsOfIsl: { links: [], viewDefault: 'Listado' },
  mapTypes: [],
  notes: {},
  textSettings: {}
};

MapsAdvancedModalStepTwo.propTypes = {
  connections: PropTypes.object,
  defaultComponent: PropTypes.string,
  handleDisabledFinish: PropTypes.func,
  ipsOfIsl: PropTypes.object,
  listComponentsAdvanced: PropTypes.object.isRequired,
  mapTypes: PropTypes.array,
  notes: PropTypes.object,
  setDefaultComponent: PropTypes.func.isRequired,
  textSettings: PropTypes.object,
  settingsAdvanced: PropTypes.object.isRequired,
  userControlSetting: PropTypes.object.isRequired
};
